import { atom } from 'recoil';

export const PlatformAtom = atom({
  key: 'PlatformAtom',
  default: {
    isMobile: false,
    currentOs: navigator.platform.toUpperCase(),
  },
});
